"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageActionMenu = PageActionMenu;

var _react = _interopRequireDefault(require("react"));

var _orderBy = _interopRequireDefault(require("lodash/orderBy"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonWithIcon = require("../forms/ButtonWithIcon");

var _icons = require("../constants/icons");

var _HorizontalFlex = require("../containers/HorizontalFlex");

var _MoreMenu = require("./MoreMenu");

var _useWindowSize = require("../hooks/useWindowSize");

var _screenSizeConstants = require("../constants/screenSizeConstants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function organizePageActions(pageActions) {
  var orderedActions = (0, _orderBy["default"])(pageActions, 'sortOrder');

  if (orderedActions.length <= 3) {
    return {
      iconActions: orderedActions,
      menuActions: null
    };
  }

  return {
    iconActions: orderedActions.slice(0, 2),
    menuActions: orderedActions.slice(2)
  };
}

function renderIconAction(iconAction) {
  if (iconAction.subActions) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: iconAction.sortOrder,
      className: "page-action-icon",
      title: iconAction.description
    }, /*#__PURE__*/_react["default"].createElement(_MoreMenu.MoreMenu, {
      isPrimaryAction: true,
      iconClass: iconAction.iconClass,
      menuItems: iconAction.subActions,
      hasDividers: false
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    key: iconAction.sortOrder,
    className: "page-action-icon",
    title: iconAction.description
  }, /*#__PURE__*/_react["default"].createElement(_ButtonWithIcon.ButtonWithIcon, {
    iconClass: iconAction.iconClass,
    onClick: iconAction.onClick,
    disabled: iconAction.isDisabled
  }));
} // eslint-disable-next-line complexity


function PageActionMenu(props) {
  var windowSize = (0, _useWindowSize.useWindowSize)();

  function renderHelpIcon() {
    if (!props.pageHelpUrl) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "page-action-icon"
    }, /*#__PURE__*/_react["default"].createElement(_ButtonWithIcon.ButtonWithIcon, {
      iconClass: _icons.icons.questionOutlined,
      onClick: function onClick() {
        props.onActionClick('Help');
        window.open(props.pageHelpUrl);
      }
    }));
  }

  if (props.pageActions.length === 0) {
    return renderHelpIcon();
  }

  var actionsWithOnClick = props.pageActions.map(function (pageAction) {
    var action = _objectSpread({}, pageAction);

    action.onClick = function () {
      props.onActionClick(pageAction.description);
      pageAction.onClick();
    };

    if (pageAction.subActions) {
      action.subActions = pageAction.subActions.map(function (subAction) {
        return _objectSpread(_objectSpread({}, subAction), {}, {
          onClick: function onClick() {
            props.onActionClick(subAction.description);
            subAction.onClick();
          }
        });
      });
    }

    return action;
  });

  if (windowSize.width <= _screenSizeConstants.mobileScreenWidth) {
    var orderedPageActions = (0, _orderBy["default"])(actionsWithOnClick, 'sortOrder');
    return /*#__PURE__*/_react["default"].createElement(_HorizontalFlex.HorizontalFlex, null, renderHelpIcon(), /*#__PURE__*/_react["default"].createElement("div", {
      className: "page-action-icon"
    }, /*#__PURE__*/_react["default"].createElement(_MoreMenu.MoreMenu, {
      isPrimaryAction: true,
      menuItems: orderedPageActions
    })));
  }

  var organizedPageActions = organizePageActions(actionsWithOnClick);
  return /*#__PURE__*/_react["default"].createElement(_HorizontalFlex.HorizontalFlex, null, organizedPageActions.iconActions.map(renderIconAction), renderHelpIcon(), organizedPageActions.menuActions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-action-icon"
  }, /*#__PURE__*/_react["default"].createElement(_MoreMenu.MoreMenu, {
    isPrimaryAction: true,
    menuItems: organizedPageActions.menuActions
  })));
}

PageActionMenu.propTypes = {
  pageActions: _propTypes["default"].instanceOf(Array),
  onActionClick: _propTypes["default"].func,
  pageHelpUrl: _propTypes["default"].string
};
PageActionMenu.defaultProps = {
  onActionClick: function onActionClick() {},
  pageActions: []
};